import React, { useState } from 'react';
import { string, bool } from 'prop-types';
import classnames from 'classnames';
import './style.scss';

const GridImage = ({
    imagePath,
    responsive = true
}) => {
    const [isCSR] = useState(typeof window !== 'undefined');
    const [errorLoading, setErrorLoading] = useState(false);

    const imageAvailable = imagePath && isCSR && !errorLoading;
    const classes = classnames('project-img', { 'hide-on-error': !imageAvailable, 'responsive-wrapper': responsive });
    const imageError = () => {
        setErrorLoading(true);
    };

    return (
        <div className={classes}>
            { imageAvailable ? <img src={imagePath} onError={imageError}/> : null }
        </div>
    );
};

GridImage.propTypes = {
    imagePath: string,
    responsive: bool
};

export default GridImage;
